module.exports = __webpack_public_path__ + "img/diagram-360_tablet.9ffb131c.jpg";